import API from "../core/api";
import { awaitTask } from "../core/tasks/actions";
import {
  clearChanges,
  clearCreation,
  clearRemoval,
  commitChanges,
  commitRemoval,
  deleteResource,
  fetchResource,
  invalidateCollections,
  reorderResource,
  stageChanges,
  stageCreation,
  stageRemoval,
  updateResource,
} from "../resources/actions";
import isEmpty from "lodash/isEmpty";

const Photos = {
  NAME: "photos",
  PATH: "photos",
};

const processUpload =
  (
    name,
    key,
    originalUUID,
    createdAt = null,
    errorCallback = () => {},
    successCallback = () => {},
  ) =>
  (dispatch) =>
    new Promise((resolve, reject) => {
      const cancel = (error) => {
        dispatch(
          clearCreation(name, {
            key,
          }),
        );
        dispatch(invalidateCollections(name));
        reject(error);
        errorCallback();
      };

      const params = {
        name: key,
        originalUUID,
      };

      if (createdAt) {
        params.createdAt = createdAt;
      }

      API.post(`${name}/process`, {}, params)
        .then((image) => {
          if (isEmpty(image.task)) {
            // There is no task, resolve
            dispatch(
              clearCreation(name, {
                key,
              }),
            );
            dispatch(invalidateCollections(name));
            resolve(image.result);
          } else {
            // There was a task, but we short-circuit by using the initial image upload until the task completes
            if (image.result) {
              resolve(image);
              dispatch(
                clearCreation(name, {
                  key,
                }),
              );
              dispatch(invalidateCollections(name));
            }

            // There is a task, wait for it to complete before resolving
            dispatch(awaitTask(image.task, 2000, 15))
              .then((data) => {
                dispatch(invalidateCollections(name));
                dispatch(
                  clearCreation(name, {
                    key,
                  }),
                );
                successCallback(data);
                resolve(data);
              })
              .catch(cancel);
          }
        })
        .catch(cancel);
    });

const addVersion = (name, id, versionKey, imageKey) => () =>
  API.post(
    `${name}/${id}/add_version`,
    {},
    {
      key: versionKey,
      name: imageKey,
    },
  );

const bulkDelete = (name, ids) => () =>
  API.post(`${name}/bulk_delete`, {}, { ids });

const deleteImage = (name, path, id) => deleteResource(name, path, id);

const updateImage = (name, id, data) => updateResource(name, id, data);

const commitImageRemoval = (name, path, id, uuid) =>
  commitRemoval(name, path, id, uuid, [], true);

const commitImageChanges = (name, id) => commitChanges(name, id);

export const reorderPhotos = (data) => reorderResource(Photos.NAME, data);

export default {
  addVersion: addVersion.bind(null, Photos.NAME),
  bulkDelete: bulkDelete.bind(null, Photos.NAME),
  clearChanges: clearChanges.bind(null, Photos.NAME),
  clearCreation: (params) => clearCreation(Photos.NAME, params),
  clearRemoval: clearRemoval.bind(null, Photos.NAME),
  commitChanges: commitImageChanges.bind(null, Photos.NAME),
  commitRemoval: commitImageRemoval.bind(null, Photos.NAME, Photos.PATH),
  deleteResource: deleteImage.bind(null, Photos.NAME, Photos.PATH),
  fetch: fetchResource.bind(null, Photos.NAME, Photos.PATH),
  fetchCollection: fetchResource.bind(null, Photos.NAME, Photos.PATH),
  processUpload: processUpload.bind(null, Photos.NAME),
  reorder: reorderPhotos,
  stageChanges: stageChanges.bind(null, Photos.NAME),
  stageCreation: (params, data) => stageCreation(Photos.NAME, data, params),
  stageRemoval: stageRemoval.bind(null, Photos.NAME),
  updateResource: updateImage.bind(null, Photos.NAME),
};
